import { createPaisaApi } from "./api-client"

export const api = createPaisaApi()
